import { AppModal } from '@Common/AppModal';
import { ExclamationTriangleIcon } from '@heroicons/react/20/solid';
import { SetStateType } from 'commonTypes';
import { FormattedMessage } from 'react-intl';

interface AlertModalProps {
  open: boolean;
  setOpen: SetStateType<boolean>;
  nextThemeType: 'dark' | 'light' | 'custom';
  setThemeType: SetStateType<'dark' | 'light' | 'custom'>;
}

export const AlertModal = ({
  open,
  setOpen,
  nextThemeType,
  setThemeType,
}: AlertModalProps) => {
  return (
    <AppModal open={open}>
      <div className="rounded-md bg-yellow-50 p-4">
        <div className="flex">
          <div className="flex-shrink-0">
            <ExclamationTriangleIcon
              className="h-5 w-5 text-yellow-400"
              aria-hidden="true"
            />
          </div>
          <div className="ml-3">
            <h3 className="text-sm font-medium text-yellow-800">
              <FormattedMessage id="attentionNeeded" />
            </h3>
            <div className="mt-2 text-sm text-yellow-700">
              <p>
                <FormattedMessage id="changeThemeTypeAlerts" />
              </p>
            </div>
          </div>
        </div>
      </div>
      <div className="w-full flex justify-end mt-4 justify-self-end space-x-4">
        <button
          type="button"
          onClick={() => setOpen(false)}
          className="rounded-md bg-white px-3.5 py-2.5 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50"
        >
          <FormattedMessage id="cancel" />
        </button>
        <button
          type="button"
          onClick={() => {
            setThemeType(nextThemeType);
            setOpen(false);
          }}
          className="rounded-md bg-indigo-600 px-3.5 py-2.5 text-sm font-semibold text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
        >
          <FormattedMessage id="confirm" />
        </button>
      </div>
    </AppModal>
  );
};
